<template>
  <div class="plan-log-panel">
    <UiLoadingSpinner v-if="loading" size="small" :message="t('task.home.taskModal.loadingLog')" />

    <UiEmpty v-else-if="!logs.length" icon-type="document" :title="t('task.home.taskModal.noLog')" />

    <div v-else class="plan-log-list">
      <div v-for="(entry, index) in logs" :key="`${entry.logDt}-${index}`" class="plan-log-item">
        <div class="plan-log-item__meta">
          <span class="plan-log-item__user">{{ entry.userNm }}</span>
          <span v-if="entry.logTypeNm" class="plan-log-item__type">{{ entry.logTypeNm }}</span>
        </div>
        <p class="plan-log-item__msg">{{ entry.logMsg }}</p>
        <p class="plan-log-item__date">{{ entry.logDt }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n();

defineProps({
  logs: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
.plan-log-panel {
  min-height: 80px;
}

.plan-log-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.plan-log-item {
  padding: 12px 0;
  border-bottom: 1px solid var(--color-gray-10, #e6e8ea);

  &:last-child {
    border-bottom: none;
  }

  &__meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 6px;
  }

  &__user {
    font-size: 13px;
    font-weight: 600;
    color: #464c53;
  }

  &__type {
    margin-left: 2px;
    color: #718ebd;
    font-size: 12px;
  }

  &__msg {
    margin: 0 0 4px;
    font-size: 13px;
    line-height: 1.5;
    color: #333;
    word-break: break-word;
  }

  &__date {
    margin: 0;
    font-size: 12px;
    color: #8a949e;
  }
}
</style>
